import { makeStylesheetLink } from "@self/stylesheet";

export class GiftCardCheckbox extends HTMLElement {
	shadow: ShadowRoot;
	input: HTMLInputElement;
	onClick: () => void;

	constructor() {
		super();

		this.shadow = this.attachShadow({ mode: "open" });

		this.onClick = onClick.bind(this);

		this.input = <input type="checkbox" name="giftCardCode" /> as HTMLInputElement;

		this.shadow.append(
			<label className="gct-custom-checkbox">
				{this.input}
				<span>Have a gift card?</span>
			</label>,
			makeStylesheetLink(),
		);
	}

	connectedCallback() {
		this.input.addEventListener("click", this.onClick);
	}

	disconnectedCallback() {
		this.input.removeEventListener("click", this.onClick);
	}
}

function onClick(this: GiftCardCheckbox) {
	const giftCard = document.getElementById("gift-card-code");
	if (giftCard) {
		if (this.input.checked) {
			giftCard.style.display = "flex";
		} else {
			giftCard.style.display = "none";
		}
	}
}
